module.exports = __webpack_public_path__ + "img/left.75e56f5d.jpg";